import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { redirectToAccountLoginUrl } from '../../authn/utils/login-redirect.utils';
import { LoadingService } from '../../shared/services/loading.service';
import { LocalStorageKeys } from '../models/auth.models';
import { ErrorService } from '../services/error.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
	const errorService = inject(ErrorService);
	const loading = inject(LoadingService);

	return next(req).pipe(
		catchError((error: HttpErrorResponse) => {
			if (error.error?.message === 'Not authenticated') {
				localStorage.removeItem(LocalStorageKeys.access_token);
				errorService.hideGeneralError();
				loading.hide();
				redirectToAccountLoginUrl();
			}

			return throwError(() => error);
		}),
	);
};
